var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSurvey)?_c('div',{staticClass:"survey-link alert alert-primary active"},[_vm._v("\nPlease tell us about your order experience: "),_c('a',{attrs:{"href":"https://brandlyinc.typeform.com/to/adZTzG"}},[_vm._v("take the last mini-survey now")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b661995e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SurveyLink.vue
// module id = icR4
// module chunks = 1